/**
 * Store Config Resource Client
 * Axios-based API client for store configuration endpoints
 */
export class StoreConfigResource {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    /**
     * Get store configuration by store ID
     */
    async getStoreConfig(storeId) {
        const response = await this.apiClient.get(`/api/v1/checkout/config?storeId=${storeId}`);
        return response;
    }
}
